<template>
 <div id="abo">
   <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal border-b">
      <b-row>
        <b-col cols="12" md="1"  class="div-back">
          <a href="javascript:history.back()" class="normallink history-back">
              <svg class="icon-back" width="57px" height="33px" version="1.1" id="Ebene_1"  x="0px" y="0px" viewBox="0 0 57 33" style="enable-background:new 0 0 57 33;" xml:space="preserve">
              <title>back</title>
              <polygon points="56.2,15 6.1,15 18.6,2.6 16.4,0.4 0.4,16.5 16.4,32.6 18.6,30.4 6.1,18 56.2,18 "/>
              </svg>
          </a>
        </b-col>
        <b-col cols="12" md="11">
            <h1> {{ entry.ausgabeTitel }} </h1>
            
            <div class="spacing-bio" v-bind:class="{ sidebarBox: entry.showMore, sidebarBoxOpen: sidebarBoxOpen  }"> 
              <p> {{ entry.ausgabeEditorial }} </p>
            </div>
            <div v-if="entry.showMore">
                <div class="" @click="readMore =! readMore, sidebarBoxOpen =! sidebarBoxOpen" v-if="readMore">
                  <div class="white-back">
                    <p>Mehr anzeigen…</p>
                  </div>
                </div>     
                <div class="read-less" @click="readMore =! readMore, sidebarBoxOpen =! sidebarBoxOpen" v-else>
                  <p>Weniger anzeigen…</p>
                </div>
              </div>

            <div class="spacing-bio" v-if="entry.pdfDownloads">
               <template v-for="block in entry.pdfDownloads">
                <div v-if="block.__typename == 'pdfDownloads_pdfDownload_BlockType'" :key="block.uid">            
                  <template v-for="rel in block.pdfDatei">
                    <a :href="rel.url" :key="rel.uid" target="_blank" class="icon-info">
                      <svg class="icon-info-desktop" width="19px" height="17px"  version="1.1" id="Ebene_1"  x="0px" y="0px" viewBox="0 0 18.4 17.5" style="enable-background:new 0 0 18.4 17.5;" xml:space="preserve">
                            <title>info-download-mobile+desktop</title>
                            <polygon points="10.2,15.4 18.4,7.2 17,5.8 10.2,12.6 10.2,0 8.2,0 8.2,12.6 1.4,5.8 0,7.2 8.2,15.4 8.2,15.5 0.7,15.5 0.7,17.5 
                                17.7,17.5 17.7,15.5 10.2,15.5 "/>
                            </svg>  
                      {{ block.dateiName }}
                    </a>
                  </template>
                </div>
              </template>
            </div>    
        
        </b-col>
      </b-row>
    </b-container>
    <relatedArticleEdition :editionId="entry.id"></relatedArticleEdition>
  </div>
</template>

<script>
  import Navigation from "@/components/_navigation";
  import RelatedArticleEdition from "@/components/_relatedArticleEdition";
  const axios = require("axios");

  export default {
    name: "Ausgabe",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
    RelatedArticleEdition
  },
  data() {
    return {
      entrySlug: this.$route.params.slug,
      entry: [],
      navigationPlaceholder: "Artikel Archiv",
      readMore: true,
      sidebarBoxOpen: false

    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                autor:entries(section: "ausgabe", slug: "` + this.entrySlug +`") {
                title,
                uid,
                id
               	... on ausgabe_ausgabe_Entry {
                  showMore,
                  ausgabejahr,
                  ausgabeTitel,
                  ausgabeEditorial,
 									pdfDownloads { # Matrix Field Handle
                     ... on pdfDownloads_pdfDownload_BlockType { # Matrix Block Type
                    __typename # Ensures the response has a field describing the type of block
                    uid,
                    dateiName,
                    pdfDatei {
                      id,
                      uid,
                      url
                    }
                    }
                  }
                }             
              }
              }
            `
      }
    }).then((result) => {
    // console.log(result)
    let data = result.data.data.autor[0];
    //console.log(data)
    this.entry = data;
  });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>